export default "__VITE_ASSET__Yml8lCbe__"